const defaults = require('./defaults');

module.exports = {
  ...defaults,
  mode: 'development',
  urlRoot: 'https://staging.ls-www.localsearch.cloud',
  serviceApiRoot: 'https://staging.services.lsapis.com.au',
  serviceGraphqlRoot: 'https://staging.services.lsapis.com.au/graphql',
  imageResizeRoot: 'https://images.staging.ls-www.localsearch.cloud',
  logger: {
    ...defaults.logger,
    console: {
      level: 'error',
    },
  },
  recaptchaMinScore: 0,
};
